import { CollapsibleSection, Pills } from '@amelio/ui-library';

import { SkillItem } from './SkillItem';

import { useAmelioTranslations } from '@/hooks';

interface Skill {
    id: string;
    name: string;
    description: string;
    questions: number;
}

interface SkillCategoryAccordionProps {
    /** Category display name */
    category: string;
    /** Skills in this category */
    skills: Skill[];
    /** Whether the accordion is expanded */
    isOpen: boolean;
    /** Toggle expand/collapse */
    onToggle: () => void;
    /** Callback when a skill is removed */
    onRemoveSkill: (skillId: string) => void;
}

export const SkillCategoryAccordion = ({
    category,
    skills,
    isOpen,
    onToggle,
    onRemoveSkill,
}: SkillCategoryAccordionProps) => {
    const { t } = useAmelioTranslations();

    const header = (
        <div className={'flex flex-col items-center gap-3 py-1 sm:flex-row'}>
            <h4 className={'text-md font-medium text-gray-900'}>{category}</h4>

            <Pills
                variant={'purple'}
                size={'sm'}
                className={'!h-[26px] !text-[11px]'}
            >
                {t('managerAssessmentSetup.competencyCount', { count: skills.length })}
            </Pills>
        </div>
    );

    return (
        <CollapsibleSection
            header={header}
            isOpen={isOpen}
            onToggle={onToggle}
            variant={'card'}
        >
            <div className={'flex flex-col'}>
                {skills.map((skill) => (
                    <SkillItem
                        key={skill.id}
                        {...skill}
                        onRemove={onRemoveSkill}
                    />
                ))}
            </div>
        </CollapsibleSection>
    );
};
